import React from 'react';
import Icon from 'framework-ui-components/Components/Icons/Icon';

export default Icon(
  <g transform="translate(-65 -387)">
    <g transform="translate(66 388)">
      <path className="a" d="M143.9,462.533H66V363H200.154v43.275" transform="translate(-66 -337.035)" />
      <path className="a" d="M81.655,368.31V355.328a4.328,4.328,0,0,0-8.655,0v4.327" transform="translate(-57.854 -351)" />
      <path className="a" d="M125.655,368.31V355.328a4.328,4.328,0,0,0-8.655,0v4.327" transform="translate(-6.648 -351)" />
      <path className="a" d="M191.5,355h8.655v17.31H66V355H89.8" transform="translate(-66 -346.345)" />
      <line className="a" x2="88.526" transform="translate(30.155 8.852)" />
      <line className="a" x2="117.688" transform="translate(8.283 17.184)" />
      <g transform="translate(12.45 41.138)">
        <line className="a" x2="5.207" transform="translate(0 0)" />
        <line className="a" x2="4.166" transform="translate(17.705 0)" />
        <line className="a" x2="4.166" transform="translate(35.411 0)" />
        <line className="a" x2="5.207" transform="translate(52.074 68.738)" />
      </g>
      <g transform="translate(8.284 35.932)">
        <rect className="b" width="12.498" height="11.456" transform="translate(87.485 0)" />
        <rect className="b" width="11.456" height="11.456" transform="translate(69.78 0)" />
        <rect className="b" width="13.539" height="11.456" transform="translate(52.074 0)" />
        <rect className="b" width="12.498" height="13.539" transform="translate(87.485 15.622)" />
        <rect className="b" width="13.539" height="11.456" transform="translate(104.149 0)" />
        <rect className="b" width="13.539" height="13.539" transform="translate(104.149 15.622)" />
        <rect className="b" width="11.456" height="13.539" transform="translate(69.78 15.622)" />
        <rect className="b" width="13.539" height="13.539" transform="translate(52.074 15.622)" />
        <rect className="b" width="13.539" height="13.539" transform="translate(34.369 15.622)" />
        <rect className="b" width="12.498" height="13.539" transform="translate(17.705 15.622)" />
        <rect className="b" width="13.539" height="13.539" transform="translate(0 15.622)" />
        <rect className="b" width="13.539" height="13.539" transform="translate(52.074 33.328)" />
        <path className="c" d="M0,0H13.539V13.539H0Z" transform="translate(34.369 33.328)" />
        <rect className="b" width="12.498" height="13.539" transform="translate(17.705 33.328)" />
        <rect className="b" width="13.539" height="13.539" transform="translate(0 33.328)" />
        <rect className="b" width="13.539" height="12.498" transform="translate(34.369 51.033)" />
        <rect className="b" width="13.539" height="12.498" transform="translate(52.074 51.033)" />
        <rect className="b" width="12.498" height="12.498" transform="translate(17.705 51.033)" />
        <rect className="b" width="13.539" height="12.498" transform="translate(0 51.033)" />
        <rect className="b" width="13.539" height="13.539" transform="translate(34.369 67.697)" />
        <rect className="b" width="12.498" height="13.539" transform="translate(17.705 67.697)" />
        <rect className="b" width="13.539" height="13.539" transform="translate(0 67.697)" />
      </g>
      <g transform="translate(80.146 71.343)">
        <circle className="c" cx="20.83" cy="20.83" r="20.83" transform="translate(6.249 6.249)" />
        <circle className="d" cx="27.079" cy="27.079" r="27.079" transform="translate(0 0)" />
      </g>
      <text className="e" transform="translate(102.842 109)">
        <tspan x="0" y="0">!</tspan>
      </text>
    </g>
  </g>,
  '0 0 136.303 127.5',
  'LogoScadenze',
);
